<template>
  <section class="hero-section">
    <!-- Ambient glowing background -->
    <div class="hero-section__ambient-glow"></div>
    <div class="hero-section__ambient-glow hero-section__ambient-glow--alt"></div>

    <div class="hero-section__grid">
      <!-- Main Featured: Guides (Left Side) -->
      <div v-if="guidesArticles.length > 0" class="hero-section__main">
        <a :href="`/${guidesArticles[0].category}/${guidesArticles[0].slug}/`" class="hero-card hero-card--large">
          <div class="hero-card__image-wrapper">
            <img v-if="guidesArticles[0].image || guidesArticles[0].featuredImage" :src="guidesArticles[0].image || guidesArticles[0].featuredImage" :alt="guidesArticles[0].title" />
            <div class="hero-card__gradient-overlay"></div>
          </div>

          <div class="hero-card__content-layer">
            <div class="hero-card__glass-panel">
              <span class="hero-card__badge">GUIDES</span>
              <h1 class="hero-card__title">{{ guidesArticles[0].title }}</h1>
              <p class="hero-card__excerpt">{{ guidesArticles[0].excerpt }}</p>

              <div class="hero-card__action">
                <span class="hero-card__read-more">Read Full Story
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                </span>
              </div>
            </div>
          </div>

          <!-- Animated Border Glow -->
          <div class="hero-card__animated-border"></div>
        </a>
      </div>

      <!-- Secondary: Reviews + News (Right Side Stack) -->
      <div class="hero-section__sidebar">
        <!-- Reviews -->
        <a v-if="reviewsArticles.length > 0"
          :href="`/${reviewsArticles[0].category}/${reviewsArticles[0].slug}/`"
          class="hero-card hero-card--small"
        >
          <div class="hero-card__image-wrapper">
            <img v-if="reviewsArticles[0].image || reviewsArticles[0].featuredImage" :src="reviewsArticles[0].image || reviewsArticles[0].featuredImage" :alt="reviewsArticles[0].title" />
            <div class="hero-card__gradient-overlay hero-card__gradient-overlay--solid"></div>
          </div>
          <div class="hero-card__content-layer hero-card__content-layer--small">
            <span class="hero-card__badge hero-card__badge--secondary">REVIEWS</span>
            <h2 class="hero-card__title hero-card__title--small">{{ reviewsArticles[0].title }}</h2>
          </div>
          <div class="hero-card__animated-border"></div>
        </a>

        <!-- News -->
        <a v-if="newsArticles.length > 0"
          :href="`/${newsArticles[0].category}/${newsArticles[0].slug}/`"
          class="hero-card hero-card--small"
        >
          <div class="hero-card__image-wrapper">
            <img v-if="newsArticles[0].image || newsArticles[0].featuredImage" :src="newsArticles[0].image || newsArticles[0].featuredImage" :alt="newsArticles[0].title" />
            <div class="hero-card__gradient-overlay hero-card__gradient-overlay--solid"></div>
          </div>
          <div class="hero-card__content-layer hero-card__content-layer--small">
            <span class="hero-card__badge hero-card__badge--secondary">NEWS</span>
            <h2 class="hero-card__title hero-card__title--small">{{ newsArticles[0].title }}</h2>
          </div>
          <div class="hero-card__animated-border"></div>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  computed: {
    // 分别获取三个板块的最新文章
    guidesArticles() {
      return this.$store.getters['articles/getArticlesByCategory']('guides') || []
    },
    reviewsArticles() {
      return this.$store.getters['articles/getArticlesByCategory']('reviews') || []
    },
    newsArticles() {
      return this.$store.getters['articles/getArticlesByCategory']('news') || []
    }
  },
}
</script>

<style lang="scss" scoped>
@use '@/css/variables.scss' as *;
@use 'sass:color';

.hero-section {
  position: relative;
  padding: rem(32) 0;
  background: transparent;
  overflow: hidden;

  @include pc {
    padding: rem(64) 0;
  }

  &__ambient-glow {
    position: absolute;
    top: -20%;
    left: -10%;
    width: 50%;
    height: 100%;
    background: radial-gradient(circle, rgba($primary-color, 0.15) 0%, rgba(0,0,0,0) 60%);
    filter: blur(80px);
    z-index: 0;
    pointer-events: none;
    animation: pulseGlow 8s infinite alternate;
    
    &--alt {
      top: 20%;
      left: auto;
      right: -10%;
      background: radial-gradient(circle, rgba($secondary-color, 0.1) 0%, rgba(0,0,0,0) 60%);
      animation: pulseGlow 10s infinite alternate-reverse;
    }
  }

  &__grid {
    position: relative;
    z-index: 1;
    max-width: $container-max-width;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr;
    gap: rem(24);
    padding: 0 rem(24);

    @include pc {
      grid-template-columns: 1.8fr 1fr;
      gap: rem(32);
    }
  }

  &__main {
    height: rem(450);
    @include pc {
      height: rem(650);
    }
  }

  &__sidebar {
    display: flex;
    flex-direction: column;
    gap: rem(24);
    height: 100%;

    .hero-card {
      flex: 1;
      height: rem(250);
      @include pc {
        height: auto;
      }
    }
  }
}

/* Animations */
@keyframes pulseGlow {
  0% { transform: scale(1); opacity: 0.8; }
  100% { transform: scale(1.1); opacity: 1; }
}

@keyframes gradientBorder {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.hero-card {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  border-radius: $border-radius-lg;
  overflow: hidden;
  text-decoration: none;
  background: $bg-secondary;
  transition: transform $transition-speed cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(255, 255, 255, 0.05);

  &:hover {
    transform: translateY(-8px) scale(1.01);
    box-shadow: 0 30px 60px -15px rgba(0, 0, 0, 0.5);
  }

  &__image-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    }
  }

  &:hover &__image-wrapper img {
    transform: scale(1.08);
  }

  &__gradient-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 40%, rgba(0,0,0,0.1) 100%);
    transition: background 0.5s ease;
    
    &--solid {
      background: linear-gradient(to top, rgba(0,0,0,0.95) 0%, rgba(0,0,0,0.6) 60%, rgba(0,0,0,0.2) 100%);
    }
  }

  &:hover &__gradient-overlay {
    background: linear-gradient(to top, rgba($bg-primary, 1) 0%, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0.2) 100%);
  }

  &__content-layer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: rem(24);
    z-index: 10;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    @include pc {
      padding: rem(40);
      width: 85%;
    }
    
    &--small {
      width: 100%;
      padding: rem(24);
    }
  }

  &__glass-panel {
    background: rgba(18, 18, 22, 0.65);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    padding: rem(24);
    border-radius: $border-radius;
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 10px 30px rgba(0,0,0,0.3);
    transition: transform $transition-speed, border-color $transition-speed;

    @include pc {
      padding: rem(32);
    }
  }

  &:hover &__glass-panel {
    border-color: rgba($primary-color, 0.3);
    transform: translateY(-4px);
  }

  &__badge {
    display: inline-block;
    background: linear-gradient(90deg, $primary-color, color.adjust($primary-color, $lightness: -10%));
    color: #fff;
    font-family: $font-family-heading;
    font-size: rem(12);
    font-weight: 700;
    padding: rem(6) rem(12);
    border-radius: rem(20);
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: rem(16);
    box-shadow: 0 4px 10px rgba($primary-color, 0.3);

    &--secondary {
      background: rgba(255,255,255,0.1);
      backdrop-filter: blur(8px);
      box-shadow: none;
      border: 1px solid rgba(255,255,255,0.2);
    }
  }

  &__title {
    color: $text-primary;
    font-family: $font-family-heading;
    font-size: rem(28);
    font-weight: 800;
    line-height: 1.2;
    margin-bottom: rem(12);
    letter-spacing: -0.5px;
    text-shadow: 0 2px 4px rgba(0,0,0,0.5);

    &--small {
      font-size: rem(22);
      margin-bottom: 0;
    }

    @include pc {
      font-size: rem(42);
      &--small {
        font-size: rem(24);
      }
    }
  }

  &__excerpt {
    color: $text-secondary;
    font-size: rem(16);
    line-height: 1.6;
    margin-bottom: rem(24);
    @include text-ellipsis(2);
    display: none;

    @include pc {
      display: -webkit-box;
    }
  }

  &__action {
    display: none;

    @include pc {
      display: block;
    }
  }

  &__read-more {
    display: inline-flex;
    align-items: center;
    gap: rem(8);
    color: $secondary-color;
    font-weight: 600;
    font-size: rem(14);
    text-transform: uppercase;
    letter-spacing: 1px;
    
    svg {
      transition: transform $transition-speed;
    }
  }

  &:hover &__read-more svg {
    transform: translateX(6px);
  }

  &__animated-border {
    position: absolute;
    inset: 0;
    border-radius: $border-radius-lg;
    padding: 2px;
    background: linear-gradient(90deg, $primary-color, $secondary-color, $accent-color, $primary-color);
    background-size: 300% 300%;
    animation: gradientBorder 6s ease infinite;
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    opacity: 0;
    transition: opacity $transition-speed;
    pointer-events: none;
  }

  &:hover &__animated-border {
    opacity: 1;
  }
}
</style>